import constants from '@/app-configs/constants'

export default [
  {
    path: '/settings',
    name: 'settings',
    component: () => import('@/views/settings/Settings.vue'),
    meta: {
      pageTitle: 'DEBTIA_SETTINGS',
      breadcrumb: [
        {
          text: 'DEBTIA_SETTINGS',
          active: true,
        },
      ],
      action: 'settings',
      resource: 'settings',
    },
  },
  {
    path: '/role-management',
    name: 'role-management',
    component: () => import('@/views/roles/Roles.vue'),
    meta: {
      pageTitle: 'DEBTIA_ROLE_MANAGEMENT',
      breadcrumb: [
        {
          text: 'DEBTIA_ROLE_MANAGEMENT',
          active: true,
        },
      ],
      action: constants.action.permissionRoleView,
      resource: constants.resource.role,
    },
  },
  {
    path: '/translations/:lang',
    name: 'translations',
    component: () => import('@/views/translations/list/Translations.vue'),
    meta: {
      pageTitle: 'DEBTIA_TRANSLATIONS',
      breadcrumb: [
        {
          text: 'DEBTIA_TRANSLATIONS',
          active: true,
        },
      ],
      navActiveLink: '',
      action: constants.action.permissionTranslationView,
      resource: constants.resource.translation,
    },
  },
]
